import { render, staticRenderFns } from "./PickYourOwnColorTray.vue?vue&type=template&id=2e4d70e2"
import script from "./PickYourOwnColorTray.vue?vue&type=script&lang=ts"
export * from "./PickYourOwnColorTray.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports